import {SetOrderAction} from '../../../store/actions/event/SetOrderAction';
import {useDispatch, useSelector} from 'react-redux';
import {EventSettingsObject} from '../../../@types/response';
import {getSettings} from '../../../store/selectors/event/getSettings';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faSortDown} from '@fortawesome/free-solid-svg-icons'
import {OrderConstants} from "../../../constants/EventsConstants";
import {AppDispatch} from "recharts/types/state/store";


export default function MonitorTable({children}: { children?: any }) {

    const settings: EventSettingsObject = useSelector(getSettings);
    const dispatch = useDispatch<AppDispatch>();

    return <div className='w-full inline-block'>
        <table className='text-table-primary w-full table-fixed'>
            <colgroup>
                {/*event_name*/}
                <col className='w-auto'/>
                {/*search*/}
                <col className='w-[15%]'/>
                {/*date*/}
                <col className='w-[12%]'/>
                {/*market*/}
                <col className='w-[12%]'/>
                {/*odd*/}
                <col className='w-[18%]'/>
            </colgroup>
            <thead>
            <tr className='uppercase 2xl:text-monitorBase text-monitorSm tracking-[-0.11px] items-center leading-normal'>
                {/*event_name + search*/}
                <th className='2xl:pl-28 pl-16 py-1 text-left'>Event/Competition</th>
                <th/>
                {/*date*/}
                <th className='py-1 text-center cursor-pointer relative' onClick={() => {
                    settings.order !== OrderConstants.DATE && dispatch(SetOrderAction(OrderConstants.DATE))
                }}>Date {settings.order === OrderConstants.DATE &&
                        <div className='absolute 2xl:right-12 right-8 top-0'>
                            <FontAwesomeIcon icon={faSortDown}/>
                        </div>
                }
                </th>
                <th/>
                {/*market*/}
                <th className='py-1 px-3 text-center'>Market</th>
                {/*odd*/}
                <th className='py-1 text-center'>Odds</th>
            </tr>
            </thead>
        </table>
        <div style={{
            background: `url('${process.env.PUBLIC_URL}/static/img/table_background.jpg')`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover'
        }}
             id='eventTable'
             className='2xl:monitor-table-wrapper border-2 border-table-primary bg-table-monitor monitor-table-wrapper-1440 overflow-auto dropdown-hidden-scrollbar relative rounded-[40px] mb-4'>
            <table className='text-table-primary w-full'>
                <colgroup>
                    {/*event_name*/}
                    <col className='w-auto'/>
                    {/*search*/}
                    <col className='w-8'/>
                    {/*date*/}
                    <col className='w-[14%]'/>
                    {/*market*/}
                    <col className='w-[14%]'/>
                    {/*odd*/}
                    <col className='w-[24%]'/>
                </colgroup>
                <tbody className='2xl:text-monitorBase text-monitorSm font-normal'>
                {children}
                </tbody>
            </table>
        </div>
    </div>
}
